/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
import ReviewsAndRatings from "./reviews-and-ratings.es6.js";
(function ($) {
  var onProviderPage = document.querySelectorAll('.paragraph--view-mode--provider')[0];
  if (onProviderPage !== undefined) {
    var reviewsAndRatings = new ReviewsAndRatings();
    reviewsAndRatings.fetchRatingsAndReviews($);
  }
})(jQuery, Drupal);